import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import Loader from "../../Components/Loader";
import Pagination from "../../Components/Pagination";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ReportDetail(props) {
  const apiToken = useContext(TokenContext);
  const query = useQuery();
  const [result, setResult] = useState();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const id = query.get("report");
    if (!id) {
      setLoading(false);
      setError("Report non specificato.");
      return;
    }

    setLoading(false);
    Repo.executeReport(apiToken, id)
      .then((response) => {
        setResult(response.data);
        setError("");
        setLoading(true);
      })
      .catch((err) => {
        console.log(err);
        const message =
          err.response?.data?.Message ||
          err.response?.data?.message ||
          "Errore durante l'esecuzione del report.";
        setError(message);
        setLoading(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const download = (type) => {
    const id = query.get("report");
    if (!id) return;

    setExporting(type);
    const request =
      type === "excel"
        ? Repo.downloadReportExcel(apiToken, id)
        : Repo.downloadReportPdf(apiToken, id);

    request
      .catch((err) => {
        console.log(err);
        const message =
          err.response?.data?.Message ||
          err.response?.data?.message ||
          "Errore durante il download.";
        setError(message);
      })
      .finally(() => setExporting(""));
  };

  return (
    <>
      <div>
        <h1>{result?.title || "Dettaglio report"}</h1>
        <div className="row">
          <div className="clearfix col-6 py-lg-2">
            <p>{result?.description || "Esecuzione del report selezionato."}</p>
          </div>
          <div className="col-6 clearfix text-right">
            <button
              type="button"
              className="btn btn-outline-primary p-2 mr-2"
              onClick={() =>
                (window.location.href = props.subfolder + "/report")
              }
            >
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-arrow-left`} />
              </svg>{" "}
              <span className="align-middle">Indietro</span>
            </button>
            <button
              type="button"
              className="btn btn-outline-primary p-2 mr-2"
              disabled={!!exporting || !result}
              onClick={() => download("excel")}
            >
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-file`} />
              </svg>{" "}
              <span className="align-middle">
                {exporting === "excel" ? "Download in corso..." : "Scarica Excel"}
              </span>
            </button>
            <button
              type="button"
              className="btn btn-outline-primary p-2"
              disabled={!!exporting || !result}
              onClick={() => download("pdf")}
            >
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-file`} />
              </svg>{" "}
              <span className="align-middle">
                {exporting === "pdf" ? "Download in corso..." : "Scarica PDF"}
              </span>
            </button>
          </div>
        </div>

        {error && (
          <div className="alert alert-danger" role="alert">
            <b>{error}</b>
          </div>
        )}

        {result && (
          <>
            <div className="mb-2">
              Record trovati: <strong>{result.rows?.length || 0}</strong>
            </div>
            <div className="table-responsive">
              <table className="table table-hover table-bordered">
                <thead>
                  <tr>
                    {(result.columns || []).map((column) => (
                      <th key={column}>{column}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows && rows.length > 0 ? (
                    rows.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {(result.columns || []).map((column) => (
                          <td key={`${rowIndex}-${column}`}>
                            {row[column] ?? ""}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={Math.max(result.columns?.length || 1, 1)}
                        className="text-center"
                      >
                        <b>Nessun risultato</b>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {result.rows && (
              <div className="p-2">
                <Pagination
                  items={result.rows}
                  setCurrentItems={setRows}
                  itemsPerPage={20}
                />
              </div>
            )}
          </>
        )}
      </div>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default ReportDetail;
